import React from "react";

const TableShimmer = ({ rows = 5, columns = 7 }) => {
  return (
    <div className="common_table_style">
      <table className="table">
        <thead>
          <tr>
            {[...Array(columns)].map((_, i) => (
              <th key={i}>
                <div className="shimmer shimmer_header" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, r) => (
            <tr key={r}>
              {[...Array(columns)].map((_, c) => (
                <td key={c}>
                  <div className="shimmer shimmer_cell" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableShimmer;
